/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ApproveTradingChallengeRegistrationRequestOptions,
  ApproveTradingChallengeRegistrationRequestStatus200,
  ApproveTradingChallengeRegistrationRequestStatus400,
  ApproveTradingChallengeRegistrationRequestStatus401,
  ApproveTradingChallengeRegistrationRequestStatus403,
  ApproveTradingChallengeRegistrationRequestStatus404,
  ApproveTradingChallengeRegistrationRequestStatus409,
  ApproveTradingChallengeRegistrationRequestStatus500,
} from '../types/ApproveTradingChallengeRegistrationRequest'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { approveTradingChallengeRegistrationRequest } from '../clients/approveTradingChallengeRegistrationRequest'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const approveTradingChallengeRegistrationRequestMutationKey = () =>
  [{ url: '/v1/trading_challenges/registration_requests/:request_id/approve' }] as const

export function approveTradingChallengeRegistrationRequestMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = approveTradingChallengeRegistrationRequestMutationKey()
  return mutationOptions<
    ApproveTradingChallengeRegistrationRequestStatus200,
    ResponseErrorConfig<
      | ApproveTradingChallengeRegistrationRequestStatus400
      | ApproveTradingChallengeRegistrationRequestStatus401
      | ApproveTradingChallengeRegistrationRequestStatus403
      | ApproveTradingChallengeRegistrationRequestStatus404
      | ApproveTradingChallengeRegistrationRequestStatus409
      | ApproveTradingChallengeRegistrationRequestStatus500
    >,
    ApproveTradingChallengeRegistrationRequestOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return approveTradingChallengeRegistrationRequest({
        ...config,
        path,
        body,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Accessible to admins (any challenge), integrators (their own tenant only) and competition managers (their assigned challenges only). Enrolment runs the same checks as add_users, so a challenge that filled up, now overlaps another of the user's challenges, or whose applicant no longer has an empty ledger is rejected with a 409 and the request stays open.
 * @summary Approve a trading challenge registration request
 * {@link /v1/trading_challenges/registration_requests/:request_id/approve}
 */
export function useApproveTradingChallengeRegistrationRequest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ApproveTradingChallengeRegistrationRequestStatus200,
      ResponseErrorConfig<
        | ApproveTradingChallengeRegistrationRequestStatus400
        | ApproveTradingChallengeRegistrationRequestStatus401
        | ApproveTradingChallengeRegistrationRequestStatus403
        | ApproveTradingChallengeRegistrationRequestStatus404
        | ApproveTradingChallengeRegistrationRequestStatus409
        | ApproveTradingChallengeRegistrationRequestStatus500
      >,
      ApproveTradingChallengeRegistrationRequestOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? approveTradingChallengeRegistrationRequestMutationKey()

  const baseOptions = approveTradingChallengeRegistrationRequestMutationOptions(
    config,
  ) as UseMutationOptions<
    ApproveTradingChallengeRegistrationRequestStatus200,
    ResponseErrorConfig<
      | ApproveTradingChallengeRegistrationRequestStatus400
      | ApproveTradingChallengeRegistrationRequestStatus401
      | ApproveTradingChallengeRegistrationRequestStatus403
      | ApproveTradingChallengeRegistrationRequestStatus404
      | ApproveTradingChallengeRegistrationRequestStatus409
      | ApproveTradingChallengeRegistrationRequestStatus500
    >,
    ApproveTradingChallengeRegistrationRequestOptions,
    TContext
  >

  return useMutation<
    ApproveTradingChallengeRegistrationRequestStatus200,
    ResponseErrorConfig<
      | ApproveTradingChallengeRegistrationRequestStatus400
      | ApproveTradingChallengeRegistrationRequestStatus401
      | ApproveTradingChallengeRegistrationRequestStatus403
      | ApproveTradingChallengeRegistrationRequestStatus404
      | ApproveTradingChallengeRegistrationRequestStatus409
      | ApproveTradingChallengeRegistrationRequestStatus500
    >,
    ApproveTradingChallengeRegistrationRequestOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ApproveTradingChallengeRegistrationRequestStatus200,
    ResponseErrorConfig<
      | ApproveTradingChallengeRegistrationRequestStatus400
      | ApproveTradingChallengeRegistrationRequestStatus401
      | ApproveTradingChallengeRegistrationRequestStatus403
      | ApproveTradingChallengeRegistrationRequestStatus404
      | ApproveTradingChallengeRegistrationRequestStatus409
      | ApproveTradingChallengeRegistrationRequestStatus500
    >,
    ApproveTradingChallengeRegistrationRequestOptions,
    TContext
  >
}
